import { supabase } from '../client'

export async function getAdminByTfCustomerIri(tfCustomerIri: string) {
  const { data, error } = await supabase
    .from('admins')
    .select('*')
    .match({ tfCustomerIri })
    .limit(1)
    .single()
  return { data, error }
}
